import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserSession } from "../classes/userSession";

import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class UserSessionService {
    API_USER_SESSION_URL = config.serverAddress + ':' + config.serverPort + '/user-session/';

    constructor(private http: HttpClient) { }

    getByToken(token: string | null) {
        return this.http.get<UserSession>(this.API_USER_SESSION_URL + 'token/' + token);
    }
    create() {
        return this.http.get<UserSession>(this.API_USER_SESSION_URL + 'create');
    }
}
